import React from 'react'
import { Sort } from '../../Stats/Sorting'

interface SortsReactContext {
	sorts: Map<string, Sort>
	toggleSort: (table: string, field: string, defaultAscending?: boolean, canClear?: boolean) => void
}

export const SortsContext = React.createContext<SortsReactContext | null>(null)

export function useSorts(): SortsReactContext {

	const context = React.useContext(SortsContext)
	if (!context) {
		throw new Error(`Sort is undefined in the context.`)
	}

	return context
}
